import React from 'react';
import { getParameterFromURL } from '../utils/scripts';
import setUserLang from '~/src/utils/scripts/setUserLang';
import { isTwoPaymentBlocksPaywallEnabled } from '../utils/scripts/twoPaymentBlocksPaywall';

import EverydoggyV5 from './everydoggyV5';
import EverydoggyV10 from './everydoggyV10';
import SinglePlanCheckout from './singlePlanCheckout';

/**
 * AB-test router. Reads URL query params and renders the matching paywall variant
 * from `src/abtests/everydoggyV*`. The default design is V5; the default tariff
 * (DEFAULT_TARIFF in utils/scripts/parseTariff.ts) is applied at store init.
 */
function AbTests(): React.ReactElement {
  setUserLang({ forceEng: 'forceUserLangPage' });

  const singlePlanCheckout = getParameterFromURL('singlePlanCheckout');
  const everydoggyV10 = getParameterFromURL('everydoggyV10');
  const showV10 = Boolean(everydoggyV10) || isTwoPaymentBlocksPaywallEnabled();

  function designToShow(): React.ReactElement {
    if (singlePlanCheckout) return <SinglePlanCheckout />;
    return showV10 ? <EverydoggyV10 /> : <EverydoggyV5 />;
  }

  return <div className="app">{designToShow()}</div>;
}

export default AbTests;
